import React from "react";
import WorkoutContainerComponent from "../components/workout/workoutContainer";

export const WorkoutsPage = () => {
  return (
    <WorkoutContainerComponent />
  );
};